module.exports = __webpack_public_path__ + "static/media/book.24e2d5be.gif";